/**
 * ReportSubscribersTemplate entity class
 */

/**
 * ReportSubscribersTemplateFactory
 * returns ReportSubscribersTemplate entity class
 *
 * @class ReportSubscribersTemplateFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSubscribersTemplate} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSubscribersTemplateFactory
 */
/* @ngInject */
export default function ReportSubscribersTemplateFactory (ReportTemplate, onOffMixin) {
  /* === ReportSubscribersTemplate class === */

  /**
   * ReportSubscribersTemplate model
   *
   * @class ReportSubscribersTemplate
   * @classdesc ReportSubscribersTemplate model
   * @memberof models
   * @see models
   * @extends models.ReportTemplate
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportSubscribersTemplate entity fields
   * @return {models.ReportSubscribersTemplate} ReportSubscribersTemplate entity
   */
  function ReportSubscribersTemplate () {
    var obj = ReportTemplate.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSubscribersTemplate.prototype = Object.create(ReportTemplate.prototype)
  ReportSubscribersTemplate.prototype.constructor = ReportSubscribersTemplate

  /* === User instance methods & fields === */

  Object.assign(ReportSubscribersTemplate.prototype, {

    /**
     * url template
     *
     * @memberof models.ReportSubscribersTemplate#
     * @type {String}
     */
    _urlTemplate: 'api/reporttemplates/subscribers/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.ReportSubscribersTemplate#
     * @type {String}
     */
    _publicUrlTemplate: 'reporttemplates/subscribers/{{::id}}'

  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from ReportTemplate class
  Object.assign(ReportSubscribersTemplate, ReportTemplate)
  ReportSubscribersTemplate._name = 'ReportSubscribersTemplate'
  ReportSubscribersTemplate.init()

  // permissions
  // ReportSubscribersTemplate.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportSubscribersTemplate
}
